import Vue from "vue";
import Router from "vue-router";
import GoogleAuthService from "./services/GoogleAuthService";

Vue.use(Router);

function deleteCookie(cname){
  let expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
  document.cookie = cname + "=" + ";" + expires + ";path=/";
}

async function guardMyRoute(to, from, next) {
  try {
    const accessToken = localStorage.getItem("access_token");

    // No token at all → only allow login route
    if (!accessToken) {
      if (to.path === "/") return next(); // allow login
      return next("/");
    }

    // If user tries to access login but already has a token
    if (to.path === "/") {
      const verifyResponse = await GoogleAuthService.verify({ token: accessToken });
      if (verifyResponse.data?.valid) {
        // Valid token → skip login and go to home
        return next("/home");
      }
    }

    // For protected routes → verify normally
    const verifyResponse = await GoogleAuthService.verify({ token: accessToken });

    if (verifyResponse.data?.valid) {
      return next();
    }

    // If token invalid → try refresh
    const refreshResponse = await GoogleAuthService.refresh();
    if (refreshResponse.data?.accessToken) {
      localStorage.setItem("access_token", refreshResponse.data.accessToken);
      return next();
    }

    // If all fails → login
   // localStorage.removeItem("access_token");
    deleteCookie("refresh_token")
    return next("/");
  } catch (err) {
    console.error("Auth error:", err);

    if (err.response && err.response.status === 401) {
      try {
        const refreshResponse = await GoogleAuthService.refresh();
        if (refreshResponse.data?.accessToken) {
          localStorage.setItem("access_token", refreshResponse.data.accessToken);
          return next();
        }
      } catch (refreshErr) {
        console.error("Refresh failed:", refreshErr);
        deleteCookie("refresh_token")
        localStorage.removeItem("access_token");
        return next("/");
      }
    } else {
      deleteCookie("refresh_token")
      return next("/");
    }
  }
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/vps",
      name: "VPS List",
      beforeEnter: guardMyRoute,
      component: () => import("./components/VMList"),
    },
    {
      path: "/home",
      name: "Home",
      beforeEnter: guardMyRoute,
      component: () => import("./components/Home"),
    },
    {
      path: "/",
      name: "Login",
      beforeEnter: guardMyRoute, // ✅ add guard to handle redirect
      component: () => import("./components/LoginNew"),
    },
    {
      path: "/metadata/:selector",
      name: "Metadata",
      beforeEnter: guardMyRoute,
      component: () => import("./components/MetaDataTable"),
    },
    {
      path: "/campaigns/:id",
      name: "Campaign",
      beforeEnter: guardMyRoute,
      component: () => import("./components/DetailViewCampaign"),
    },
    {
      path: "/profile_owners/:id",
      name: "Profile Owner",
      beforeEnter: guardMyRoute,
      component: () => import("./components/DetailViewProfileOwner"),
    },
    {
      path: "/vps/:id",
      name: "VPS",
      beforeEnter: guardMyRoute,
      component: () => import("./components/DetailViewVPS"),
    },
    {
      path: "/admin",
      name: "Admin",
      beforeEnter: guardMyRoute,
      component: () => import("./components/UAMDashboard"),
    },
  ],
});
